<script>
import moment from "@wielink-application/shared/js/mixins/moment";
import {useForm} from "@inertiajs/vue3";

let timeout = null;

export default {
  mixins: [moment],
  data() {
    return {
      form: useForm({
        overdue: 0,
        months: 2,
        limit: 10
      }),
      customers: []
    }
  },
  methods: {
    getCustomers(type = 'initial') {
      if (['months', 'overdue'].includes(type)) {
        this.form.reset('limit');
      }
      timeout ? clearTimeout(timeout) : null;
      timeout = setTimeout(() => {
        $.ajax({
          url: route('api.v1.appointments.upcoming'),
          data: this.form.data(),
          success: (response) => {
            this.customers = response.data;
          }
        })
      }, 200)
    }
  },
  mounted() {
    this.getCustomers();
    this.$watch('form.overdue', this.getCustomers.bind(this, 'overdue'));
    this.$watch('form.months', this.getCustomers.bind(this, 'months'));
    this.$watch('form.limit', this.getCustomers.bind(this, 'limit'));
  }
}
</script>

<template>
  <div class="d-flex gap-2 mb-3">
    <button @click.prevent="form.overdue = 0" class="btn" :class="{'btn-primary' : form.overdue === 0, 'btn-secondary': form.overdue !== 0}">Aankomend</button>
    <button @click.prevent="form.overdue = 1" class="btn" :class="{'btn-primary' : form.overdue === 1, 'btn-secondary': form.overdue !== 1}">Verstreken</button>
  </div>

  <div class="text mb-3">
    <p><i>* Er worden alleen keuringen getoond die binnen nu en 2 maanden vallen en nog niet zijn ingepland</i></p>
  </div>

  <table class="table table-striped table-sm m-0">
    <thead>
      <tr>
        <th>Klant</th>
        <th>Vervaldatum</th>
        <th></th>
      </tr>
    </thead>

    <tbody>
      <tr v-for="customer in customers">
        <td>{{ customer.name }}</td>
        <td>{{ dateFormat(customer.valid_until) }}</td>
        <td></td>
      </tr>
    </tbody>
  </table>

  <div class="mt-3">
    <a v-if="form.limit > 0" @click.prevent="form.limit = 0" href="#">Toon alles</a>
    <a v-if="form.limit < 1" @click.prevent="form.reset('limit')" href="#">Toon minder</a>
  </div>
</template>